import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Orders from "./NewOrder";
import ReadyToShipOrders from "./ReadyToShipOrders";
import InTransitOrders from "./InTransitOrders";
import DeliveredOrders from "./DeliveredOrders";
import CancelledOrder from "./CancelledOrders";
import AllOrder from "./AllOrders";
import axios from "axios";
import { ChevronDown } from "lucide-react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import EmployeeAuthModal from "../employeeAuth/EmployeeAuthModal";


import RTO from "./RTO"
import OutForDelivery from "./OutForDeliveryOrders";
import RTOIntransit from "./RTOIntransit";
import RTODelivered from "./RTODelivered";
import RTOLost from "./RTOLost";
import RTODamaged from "./RTODamaged";
import Lost from "./Lost";
import Damaged from "./Damaged";
import { getUserInfoFromToken } from "../utils/session";
const OrderTab = ({ isSidebarAdmin }) => {
    // const [activeTab, setActiveTab] = useState("New");
    const desktopDropdownRef = useRef(null);
    // console.log("ewwew",activeTab)
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    const [refresh, setRefresh] = useState(false);
    const [orders, setOrders] = useState([]);
    const [showMoreTabs, setShowMoreTabs] = useState(false);



    const [orderIds, setOrderIds] = useState("");
    const [awbNumbers, setAwbNumbers] = useState("");
    const [productName, setProductName] = useState("");
    const [channel, setChannel] = useState("");
    const [type, setType] = useState("");
    const [courier, setCourier] = useState("");
    const [warehouse, setWarehouse] = useState("");
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [showCustomCalendar, setShowCustomCalendar] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [dateFilter, setDateFilter] = useState(""); // Add this line
    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
    });
    const [warehouseCities, setWarehouseCities] = useState([]);
    const [courierService, setCourierService] = useState([]);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const mobileDropdownRef = useRef(null);
    const [orderCounts, setOrderCounts] = useState({});
    const location = useLocation()
    const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
    const [employeeAccess, setEmployeeAccess] = useState({ isAdmin: false, canView: false });

    // const dropdownRef = useRef(null);
    const isNdrRoute = location.pathname === "/adminDashboard/ndr";
    const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem(tabStorageKey) || "New";
    });

    const params = new URLSearchParams(location.search);
    const userId = params.get("userId");
    // console.log("Order tab",userId)

    useEffect(() => {
        localStorage.setItem(tabStorageKey, activeTab);
    }, [activeTab]);




    const tabs = [
        "New",
        "Ready to Ship",
        "In Transit",
        "Out for Delivery",
        "Delivered",
        // "Cancelled",
        // "All",
        // "RTO"
    ];

    const moreTabs = ["Cancelled", "Lost", "Damaged", "RTO", "RTO In Transit", "RTO Delivered", "RTO Lost", "RTO Damaged", "All"];
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    const statusTabMap = {
        "New": "new",
        "Ready to Ship": "Ready To Ship",
        "In Transit": "In-transit",
        "Out for Delivery": "Out for Delivery",
        "Delivered": "Delivered",
        "Cancelled": "Cancelled",
        "RTO": "RTO",
        "RTO In Transit": "RTO In-transit",
        "RTO Delivered": "RTO Delivered",
        "RTO Lost": "RTO Lost",
        "RTO Damaged": "RTO Damaged",
        "Lost": "Lost",
        "Damaged": "Damaged"
    };



    useEffect(() => {
        const fetchOrders = async () => {
            try {
                console.log(isSidebarAdmin)
                if (isSidebarAdmin) {
                    console.log("data")
                    // Sidebar admin: full access, no modal, fetch orders
                    setEmployeeAccess({ isAdmin: true, canView: true });
                    setShowEmployeeAuthModal(false);

                    const [session, token] = document.cookie.split("=");
                    const response = await axios.get(
                        `${REACT_APP_BACKEND_URL}/admin/adminOrder`,
                        {
                            headers: {
                                authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    const fetchedOrders = response.data.orders;
                    console.log("fetch", fetchedOrders)
                    setOrders(fetchedOrders);
                    setRefresh(false);

                    // Count orders by status
                    const counts = {};
                    fetchedOrders.forEach((order) => {
                        for (const [tab, status] of Object.entries(statusTabMap)) {
                            if (order.status === status) {
                                counts[tab] = (counts[tab] || 0) + 1;
                            }
                        }
                    });
                    setOrderCounts(counts);
                    console.log("ordercount", counts)
                } else {
                    // Employee: check access rights
                    const [session, token] = document.cookie.split("=");
                    const employeeResponse = await axios.get(
                        `${REACT_APP_BACKEND_URL}/staffRole/verify`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                    const employeeInfo = employeeResponse.data.employee;
                    // const isAdmin = !!employeeInfo?.isAdmin;
                    const canView = !!employeeInfo?.accessRights?.orders?.['All Orders']?.view;
                    setEmployeeAccess({ canView });

                    if (!canView) {
                        setShowEmployeeAuthModal(true);
                        return;
                    }
                }

                // Fetch orders as usual
                const [session, token] = document.cookie.split("=");
                const response = await axios.get(
                    `${REACT_APP_BACKEND_URL}/admin/adminOrder`,
                    {
                        headers: {
                            authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("fetch", response.data.orders)
                const fetchedOrders = response.data.orders;
                console.log(fetchedOrders)
                setOrders(fetchedOrders);
                setRefresh(false);

                // Count orders by status
                const counts = {};
                fetchedOrders.forEach((order) => {
                    for (const [tab, status] of Object.entries(statusTabMap)) {
                        if (order.status === status) {
                            counts[tab] = (counts[tab] || 0) + 1;
                        }
                    }
                });
                setOrderCounts(counts);
                // console.log("ordercount",counts)

                // Set couriers and warehouse cities
                const courierNames = [
                    ...new Set(fetchedOrders.map((order) => order.courierServiceName)),
                ];
                setCourierService(courierNames);
                const cities = [
                    ...new Set(fetchedOrders.map((order) => order.pickupAddress?.city)),
                ];
                setWarehouseCities(cities);
            } catch (error) {
                console.error("Error fetching orders:", error);
            }
        };
        fetchOrders();
    }, [refresh, isSidebarAdmin]);

    const handleNewOrderClick = async () => {
        try {

            const [session, token] = document.cookie.split("=");

            const response = await axios.get(
                `${REACT_APP_BACKEND_URL}/users/getUsers`,
                {
                    headers: { authorization: `Bearer ${token}` },
                }
            );

            if (response.data.isSeller) {
                navigate("/dashboard/order/neworder");
            } else {
                setShowModal(true);
            }
        } catch (error) {
            console.error("Error fetching sellers:", error);
        }
    };








    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".mobile-dropdown")) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const renderTabContent = () => {
        switch (activeTab) {
            case "New":
                return <Orders userId={userId} />;
            case "Ready to Ship":
                return <ReadyToShipOrders userId={userId} />;
            case "In Transit":
                return <InTransitOrders userId={userId} />;
            case "Out for Delivery":
                return <OutForDelivery userId={userId} />;
            case "Delivered":
                return <DeliveredOrders userId={userId} />;
            case "Cancelled":
                return <CancelledOrder userId={userId} />;
            case "RTO":
                return <RTO userId={userId} />;
            case "RTO In Transit":
                return <RTOIntransit userId={userId} />;
            case "RTO Delivered":
                return <RTODelivered userId={userId} />;
            case "RTO Lost":
                return <RTOLost userId={userId} />;
            case "RTO Damaged":
                return <RTODamaged userId={userId} />;
            case "Lost":
                return <Lost userId={userId} />;
            case "Damaged":
                return <Damaged userId={userId} />;
            case "All":
                return <AllOrder userId={userId} />;
            default:
                return <div>Select a tab to view orders.</div>;
        }
    };

    //this is for date range picker
    const handleDateSuggestion = (value) => {
        let startDate, endDate;
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to the start of the day

        switch (value) {
            case "today":
                startDate = new Date(today);
                endDate = new Date(today);
                break;

            case "yesterday":
                startDate = new Date(today);
                startDate.setDate(startDate.getDate() - 1);
                endDate = new Date(startDate);
                break;

            case "last7days":
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 6); // 6 days before today (including today)
                endDate = new Date(today);
                break;

            case "thismonth":
                startDate = new Date(today.getFullYear(), today.getMonth(), 1);
                endDate = new Date(today);
                break;

            case "lastmonth":
                startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
                break;

            case "thisyear":
                startDate = new Date(today.getFullYear(), 0, 1);
                endDate = new Date(today);
                break;

            case "custom":
                setShowCustomCalendar(true); // Open the calendar for custom selection
                return; // Exit early

            default:
                return;
        }

        // Update state properly
        setSelectionRange({ startDate, endDate, key: "selection" });
        setStartDate(startDate);
        setEndDate(endDate);
        setShowCustomCalendar(false); // Close the calendar for predefined options
    };

    const applyDateFilter = (dateRange) => {
        const { startDate, endDate } = dateRange;
        setFromDate(startDate);
        setEndDate(endDate);

        // Apply filter logic based on startDate and endDate
    };

    const getToday = () => {
        const today = new Date();
        return { startDate: today, endDate: today };
    };

    const getYesterday = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return { startDate: yesterday, endDate: yesterday };
    };

    const getLast7Days = () => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6); // 7 days ago
        return { startDate: sevenDaysAgo, endDate: today };
    };

    const getThisMonth = () => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        return { startDate: firstDayOfMonth, endDate: today };
    };

    const getThisYear = () => {
        const today = new Date();
        const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
        return { startDate: firstDayOfYear, endDate: today };
    };
    const handleDateChange = (ranges) => {
        setSelectionRange(ranges.selection);
        setStartDate(ranges.selection.startDate);
        setEndDate(ranges.selection.endDate);
    };

    const handleSelect = (ranges) => {
        setStartDate(ranges.selection.startDate);
        setEndDate(ranges.selection.endDate);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                desktopDropdownRef.current &&
                !desktopDropdownRef.current.contains(event.target)
            ) {
                setShowMoreTabs(false);
            }

            if (
                mobileDropdownRef.current &&
                !mobileDropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMoreTabs(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={`md:p-2 lg:p-2 ${showModal ? "overflow-hidden" : ""}`}>
            <div className="mb-1">
                <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-700">Orders</h1>
            </div>

            {/* Tabs for larger screens */}
            <div className="flex flex-row justify-between items-center gap-4">
                <div className="hidden md:flex flex-wrap gap-2 relative">
                    {/* Only show visible tabs, not the 'more' ones */}
                    {tabs.filter(tab => !moreTabs.includes(tab)).map((tab) => (
                        <button
                            key={tab}
                            className={`px-3 py-2 text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                                ? "bg-[#0CBB7D] text-white"
                                : "bg-white text-gray-700 hover:bg-green-200"
                                }`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}

                        </button>
                    ))}


                    {/* More Dropdown */}
                    <div className="relative" ref={desktopDropdownRef}>
                        <button
                            onClick={() => setShowMoreTabs((prev) => !prev)}
                            className={`px-3 py-2 text-[12px] rounded-lg font-[600] transition-all duration-200 flex items-center gap-1 ${moreTabs.includes(activeTab)
                                ? "bg-[#0CBB7D] text-white"
                                : "bg-white text-gray-700 hover:bg-green-200"
                                }`}
                        >
                            {moreTabs.includes(activeTab) ? activeTab : "More"}
                            <ChevronDown className="w-4 h-4" />
                        </button>

                        {showMoreTabs && (
                            <div className="absolute left-0 top-full mt-1 bg-white border border-green-200 rounded-md shadow-md z-50 w-40">
                                {moreTabs.map((tab) => (
                                    <button
                                        key={tab}
                                        onClick={() => {
                                            setActiveTab(tab);
                                            setShowMoreTabs(false);
                                        }}
                                        className={`w-full text-left px-3 py-2 text-[12px] font-[600] flex justify-between items-center transition hover:bg-green-200 ${activeTab === tab
                                            ? "bg-green-200 font-[600] text-black"
                                            : ""
                                            }`}
                                    >
                                        <span>{tab}</span>

                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                </div>


                {/* New Order + Filters */}
                {/* <div className="flex md:grid md:grid-cols-2 md:mb-4 mb-2 md:w-auto w-full">
                    <button
                        onClick={handleNewOrderClick}
                        className="flex-1 px-4 py-2 bg-[#2d054b] text-purple-50 rounded-lg text-sm md:text-base"
                    >
                        + New Order
                    </button>


                </div> */}
            </div>

            {!isSidebarAdmin && showEmployeeAuthModal && (
                <EmployeeAuthModal
                    employeeModalShow={showEmployeeAuthModal}
                    employeeModalClose={() => {
                        setShowEmployeeAuthModal(false);
                        window.history.back();
                    }}
                />
            )}

            {(isSidebarAdmin || employeeAccess.isAdmin || employeeAccess.canView) && (
                <>
                    {/* Mobile Dropdown for Tabs */}

                    <div className="sm:hidden relative mb-2" ref={mobileDropdownRef}>
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="w-full flex font-[600] justify-between items-center px-3 py-2 border border-gray-300 rounded-lg bg-[#0CBB7D] shadow text-[10px] text-white"
                        >
                            {activeTab}
                            <ChevronDown className="w-3 h-3 ml-2" />
                        </button>

                        {dropdownOpen && (
                            <div
                                className="absolute left-0 top-full mt-1 w-full bg-white border rounded shadow-md z-50 max-h-60 overflow-y-auto"
                            >
                                {/* Main tabs */}
                                {tabs.map((tab) => (
                                    <button
                                        key={tab}
                                        className={`w-full text-left px-3 py-2 font-[600] text-[10px] flex justify-between items-center ${activeTab === tab ? "bg-gray-100 font-[600]" : "hover:bg-gray-50"
                                            }`}
                                        onClick={() => {
                                            setActiveTab(tab);
                                            setDropdownOpen(false);
                                        }}
                                    >
                                        <span>{tab}</span>                          
                                    </button>
                                ))}

                                {/* Divider */}
                                <div className="border-t border-gray-200 my-1" />

                                {/* More tabs */}
                                {moreTabs.map((tab) => (
                                    <button
                                        key={tab}
                                        className={`w-full text-left px-3 py-2 text-[10px] font-[600] flex justify-between items-center ${activeTab === tab ? "bg-gray-100 font-[600]" : "hover:bg-gray-50"
                                            }`}
                                        onClick={() => {
                                            setActiveTab(tab);
                                            setDropdownOpen(false);
                                        }}
                                    >
                                        <span>{tab}</span>
                                        
                                    </button>
                                ))}
                            </div>
                        )}

                    </div>
                    {/* Search and Actions */}


                    {/* Modal for KYC Incomplete */}
                    {showModal && (
                        <div className="fixed inset-0 flex items-center justify-center z-[70] p-2">
                            {/* Background overlay */}
                            <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

                            {/* Modal Content */}
                            <div className="relative bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
                                <p className="text-lg font-medium mb-4 text-center">
                                    Your KYC is incomplete, please complete your KYC to create a new
                                    order.
                                </p>
                                <div className="flex justify-center gap-4">
                                    <button
                                        className="px-6 py-2 bg-[#0CBB7D] text-purple-50 rounded-lg text-sm md:text-base"
                                        onClick={() => {
                                            navigate("/kyc");
                                            setShowModal(false);
                                        }}
                                    >
                                        OK
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg text-sm md:text-base"
                                        onClick={() => setShowModal(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Tab Content */}
                    <div className="overflow-x-auto">{renderTabContent()}</div>
                </>
            )}



        </div>
    );
};

export default OrderTab;